import { render, staticRenderFns } from "./RadvizPage.vue?vue&type=template&id=53ca942a&"
import script from "./RadvizPage.vue?vue&type=script&lang=js&"
export * from "./RadvizPage.vue?vue&type=script&lang=js&"
import style0 from "./RadvizPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RadvizPage.vue"
export default component.exports